import { PrimaryButton, TextButton } from '@joor/design-system'
import styled from 'styled-components'

import { Actions } from 'modals/ReassignConnectionsModal/reassignConnectionsModal.types'

import IDs from '../../reassignConnectionsModal.ids'
import messages from '../../reassignConnectionsModal.messages'

export const ActionButtonsContainer = styled.div`
  display: flex;
  gap: 16px;
  justify-content: end;
`

export const CancelButton = styled(TextButton)`
  text-decoration: none;
`

export const ConfirmButton = styled(PrimaryButton)`
  width: auto;
`

interface ModalActionsProps {
  isConfirmDisabled: boolean
  isReassigning: boolean
  handleConfirm: () => void
  handleOnClose: () => void
  action: keyof typeof Actions
}

const ModalActions = ({
  isConfirmDisabled,
  isReassigning,
  handleConfirm,
  handleOnClose,
  action,
}: ModalActionsProps): JSX.Element => {
  return (
    <ActionButtonsContainer>
      <CancelButton
        id={IDs.CancelButton}
        data-testid={IDs.CancelButton}
        disabled={isReassigning}
        onClick={handleOnClose}
      >
        {messages.cancel}
      </CancelButton>
      <ConfirmButton
        id={
          action === Actions.REASSIGN
            ? IDs.ConfirmReassignButton
            : IDs.ConfirmRemoveButton
        }
        data-testid={IDs.ConfirmReassignButton}
        disabled={isConfirmDisabled}
        loading={isReassigning}
        onClick={handleConfirm}
      >
        {messages.confirm}
      </ConfirmButton>
    </ActionButtonsContainer>
  )
}

export default ModalActions
